import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const isMobile = () =>
  /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

const MobileRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isMobile() && location.pathname !== "/desktop-only") {
      navigate("/desktop-only", { replace: true });
    }
  }, [navigate, location]);

  return null;
};

export default MobileRedirect;
